import { SVGProps } from 'react'

export const QuickstartIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.6285 0.477127C11.9464 0.613154 12.1301 0.948883 12.0733 1.28995L10.8855 8.41665H16.6668C16.9509 8.41665 17.2106 8.57715 17.3377 8.83124C17.4647 9.08533 17.4373 9.38939 17.2668 9.61665L9.26683 20.2833C9.05937 20.5599 8.68968 20.6589 8.37178 20.5228C8.05389 20.3868 7.87019 20.0511 7.92704 19.71L9.11482 12.5833H3.3335C3.04942 12.5833 2.78972 12.4228 2.66268 12.1687C2.53564 11.9146 2.56305 11.6106 2.7335 11.3833L10.7335 0.716653C10.941 0.440034 11.3107 0.3411 11.6285 0.477127ZM4.8335 11.0833H10.0002C10.2206 11.0833 10.4299 11.1803 10.5724 11.3485C10.7149 11.5168 10.7762 11.7392 10.74 11.9566L9.91228 16.9227L15.1668 9.91665H10.0002C9.7797 9.91665 9.5704 9.81965 9.4279 9.65143C9.2854 9.48322 9.22413 9.26082 9.26037 9.04335L10.0881 4.07724L4.8335 11.0833Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
)
